var RECOVERY_VID = '45679835873508';
var I={
  product:'https://cdn.shopify.com/s/files/1/0267/6768/7757/files/product.webp?v=1777373783',
  cosmetics:'https://cdn.shopify.com/s/files/1/0267/6768/7757/files/cosmetics.webp?v=1777373783',
  sun:'https://cdn.shopify.com/s/files/1/0267/6768/7757/files/sun.webp?v=1777373784',
  heat:'https://cdn.shopify.com/s/files/1/0267/6768/7757/files/heat.webp?v=1777373783',
  stress:'https://cdn.shopify.com/s/files/1/0267/6768/7757/files/stress.webp?v=1777373784',
  pollution:'https://cdn.shopify.com/s/files/1/0267/6768/7757/files/pollution.webp?v=1777373783',
  exercise:'https://cdn.shopify.com/s/files/1/0267/6768/7757/files/exercise.webp?v=1777373783',
  water:'https://cdn.shopify.com/s/files/1/0267/6768/7757/files/water.webp?v=1777373784',
  red_face:'https://cdn.shopify.com/s/files/1/0267/6768/7757/files/red_face.webp?v=1777373784',
  red_spots:'https://cdn.shopify.com/s/files/1/0267/6768/7757/files/red_spots.webp?v=1777373783',
  red_diffuse:'https://cdn.shopify.com/s/files/1/0267/6768/7757/files/red_diffuse.webp?v=1777373783'
};
var TC=[
  {key:'cosmetics',ch:'Ch. II',ey:'Sensitivity 01',
   q:'When you apply cosmetics or skincare products, what does your skin typically do?',
   sub:'Think about your everyday products - moisturiser, serum, sunscreen, makeup.',
   img:'cosmetics',focus:'center',
   opts:[['none','Nothing unusual - products sit fine','No reaction',0],
         ['mild','Slight redness or warmth','Fades on its own quickly',0.5],
         ['mod','Noticeable irritation or tingling','Redness or discomfort that lingers',1],
         ['sev','Burns, stings or breaks out','Clear and persistent reaction',1]]},
  {key:'sun',ch:'Ch. II',ey:'Sensitivity 02',
   q:'When you step out in the sun, what does your skin usually do?',
   sub:'Even brief exposure - a walk to the car, a few minutes outdoors.',
   img:'sun',focus:'center 30%',
   opts:[['none','Nothing - handles it fine','No reaction even on a bright day',0],
         ['mild','Goes a little warm or pink','Settles quickly on its own',0.5],
         ['mod','Reddens noticeably','Takes a while to calm down',1],
         ['sev','Burns or stings even briefly','Reacts in short exposure',1]]},
  {key:'heat',ch:'Ch. II',ey:'Sensitivity 03',
   q:'Do weather changes affect your skin?',
   sub:'Heat, cold, humidity, dry air - any shift in the weather or environment.',
   img:'heat',focus:'center',
   opts:[['none','Not really - my skin handles it fine','No change regardless of weather',0],
         ['mild','Slightly uncomfortable or dull','Minor, nothing visible',0.5],
         ['mod','Noticeably tight, dry, flushed or red','A visible or persistent change',1],
         ['sev','Reacts strongly - burning or flaring','Clear and uncomfortable',1]]},
  {key:'stress',ch:'Ch. II',ey:'Sensitivity 04',
   q:'When you go through a stressful period, what do you notice on your skin?',
   sub:'A tough week at work, a difficult time - does your skin react to it?',
   img:'stress',focus:'center 30%',
   opts:[['none','Nothing - my skin stays the same','No connection between stress and skin',0],
         ['mild','Occasional dullness or a minor breakout','Subtle, easy to overlook',0.5],
         ['mod','Flares up - redness, irritation or sensitivity','A clear pattern you recognise',1],
         ['sev','Reacts significantly - visible change','Strong and consistent reaction',1]]},
  {key:'pollution',ch:'Ch. II',ey:'Sensitivity 05',
   q:'If you spend time in a polluted or dusty area, what does your skin do?',
   sub:'Traffic, construction, dusty environments - even a commute through the city.',
   img:'pollution',focus:'center',
   opts:[['none','Nothing noticeable','No reaction',0],
         ['mild','Feels a bit grimy or dull','No visible reaction, just texture',0.5],
         ['mod','Feels irritated or looks red','Noticeable reaction after exposure',1],
         ['sev','Reacts strongly - burning or stinging','Clear and uncomfortable response',1]]},
  {key:'exercise',ch:'Ch. II',ey:'Sensitivity 06',
   q:'When you sweat during exercise, what does your skin do?',
   sub:'Gym, a run, hot yoga - any activity that makes you sweat.',
   img:'exercise',focus:'center 25%',
   opts:[['none','Nothing - no reaction','Sweat does not affect my skin',0],
         ['mild','Goes rosy but settles fast','Normal exercise flush, fades quickly',0.5],
         ['sev','Stings or burns while sweating','An uncomfortable, reactive feeling',1]]},
  {key:'water',ch:'Ch. II',ey:'Sensitivity 07',
   q:'When water touches your face - washing or swimming - what happens?',
   sub:'Plain water, not products. Think about your morning wash or a shower.',
   img:'water',focus:'70% center',
   opts:[['none','Nothing at all','Water has no effect',0],
         ['mild','Goes slightly red but settles quickly','A brief, mild reaction',0.5],
         ['sev','Stings or burns on contact','An immediate uncomfortable sensation',1]]}
];

var S={
  gender:null,
  trig:{cosmetics:null,sun:null,heat:null,stress:null,pollution:null,exercise:null,water:null},
  ts:{cosmetics:0,sun:0,heat:0,stress:0,pollution:0,exercise:0,water:0},
  hasRedness:null,rednessType:[],
  otcCreams:null,sunscreen:null,
  sleepQ:null,dietQ:null,hydroQ:null,
  photos:{front:null,left:null,right:null},
  ps:{front:null,left:null,right:null},
  isChosen:null
};

function calcScore(){
  var s=0;
  var ks=Object.keys(S.ts);
  for(var i=0;i<ks.length;i++) s+=S.ts[ks[i]];
  if(S.hasRedness==='yes') s+=1;
  if(S.otcCreams==='yes') s+=1;
  return s;
}

// var SCREENS=[
//   {id:'welcome',noProg:true},
//   {id:'gender'},
//   {id:'redness'},
//   {id:'rednesstype',show:function(){return S.hasRedness==='yes';},needsCont:true},
//   {id:'trig_cosmetics'},{id:'trig_sun'},{id:'trig_heat'},
//   {id:'trig_stress'},{id:'trig_pollution'},{id:'trig_exercise'},{id:'trig_water'},
//   {id:'otc'},
//   {id:'sunscreen'},
//   {id:'sleepQ'},{id:'dietQ'},{id:'hydroQ'},
//   {id:'photos'},
//   {id:'chosen'},
//   {id:'result',noProg:true}
// ];
var SCREENS=[
  {id:'welcome',noProg:true},
  {id:'gender'},
  {id:'redness'},
  {id:'rednesstype',show:function(){return S.hasRedness==='yes';}},
  {id:'trig_cosmetics'},{id:'trig_sun'},{id:'trig_heat'},
  {id:'trig_stress'},{id:'trig_pollution'},{id:'trig_exercise'},{id:'trig_water'},
  {id:'otc'},
  {id:'sunscreen'},
  {id:'sleepQ'},{id:'dietQ'},{id:'hydroQ'},
  {id:'photos'},
  {id:'chosen'},
  {id:'result',noProg:true}
];

function vis(){return SCREENS.filter(function(s){return !s.show||s.show();});}

var timerOn=false,secs=120,timerInt=null;
function startTimer(){
  if(timerOn) return;
  timerOn=true;
  timerInt=setInterval(function(){
    secs=Math.max(0,secs-1);
    renderTimer();
    if(secs<=0) clearInterval(timerInt);
  },1000);
}
function renderTimer(){
  var t=document.getElementById('timer');
  if(!t) return;
  var vs=vis(),cur=vs[curIdx];
  if(!timerOn||cur.id==='welcome'){t.className='timer';t.innerHTML='';return;}
  if(cur.id==='result'){
    t.className='timer on done';
    t.innerHTML='<span class="tdot"></span><span>DONE</span>';
    if(!document.getElementById('result-download-btn')){
      var btn=document.createElement('button');
      btn.id='result-download-btn';
      btn.className='result-download-btn';
      btn.setAttribute('onclick','handlePdfClick()');
      btn.setAttribute('title','Download your skin analysis PDF');
      btn.innerHTML='<i class="fa-solid fa-download"></i>';
      t.parentNode.insertBefore(btn,t.nextSibling);
    }
    return;
  }
  var m=Math.floor(secs/60),sc=secs%60;
  t.className='timer on';
  t.innerHTML='<span class="tdot"></span><span>'+m+':'+(sc<10?'0':'')+sc+'</span>';
}

var curIdx=0;
function go(idx,back){
  back=back||false;
  window.scrollTo({top:0,left:0,behavior:'smooth'});
  var waitForTop=setInterval(function(){
    if(window.scrollY<=5){
      clearInterval(waitForTop);
      curIdx=idx;
      var vs=vis(),cur=vs[idx],total=vs.length;
      var ctr=document.getElementById('counter');
      if(cur.noProg&&cur.id!=='welcome'){
        ctr.innerHTML='<span class="n">&#10003;</span>';
      } else {
        var n=String(idx+1);if(n.length<2)n='0'+n;
        var tot=String(total);if(tot.length<2)tot='0'+tot;
        ctr.innerHTML='<span class="n">'+n+'</span>/'+tot;
      }
      var bb=document.getElementById('back-btn');
      if(idx===0||cur.id==='result') bb.classList.add('hidden');
      else bb.classList.remove('hidden');
      var pr=document.getElementById('prog');
      var pticks='';
      for(var i=0;i<vs.length;i++){
        var cls=i<idx?'done':i===idx?'cur':'';
        pticks+='<div class="tick '+cls+'"></div>';
      }
      pr.innerHTML=pticks;
      var foot=document.getElementById('foot');
      var needsCont=cur.needsCont===true;
      foot.style.display=needsCont?'':'none';
      if(needsCont){
        var ok=cur.id==='rednesstype'?S.rednessType.length>0:true;
        document.getElementById('cont-btn').disabled=!ok;
        document.getElementById('cont-txt').textContent='Continue';
      }
      renderTimer();
      var content=document.getElementById('content');
      var old=content.querySelector('.screen');
      if(old) old.remove();
      var div=document.createElement('div');
      div.className='screen'+(back?' back':'');
      content.appendChild(div);
      var fn=R[cur.id];
      if(fn) fn(div);
      else div.innerHTML='<div style="padding:40px">'+cur.id+'</div>';
    }
  },16);
}
function advance(){var vs=vis();if(curIdx<vs.length-1){var ni=curIdx+1;trackSensitiveQuizStep(vs[ni].id,ni+1);go(ni,false);}}
function goBack(){if(curIdx>0)go(curIdx-1,true);}
function restart(){
  S={gender:null,trig:{cosmetics:null,sun:null,heat:null,stress:null,pollution:null,exercise:null,water:null},
    ts:{cosmetics:0,sun:0,heat:0,stress:0,pollution:0,exercise:0,water:0},
    hasRedness:null,rednessType:[],otcCreams:null,sunscreen:null,
    sleepQ:null,dietQ:null,hydroQ:null,
    photos:{front:null,left:null,right:null},ps:{front:null,left:null,right:null},isChosen:null};
  curIdx=0;timerOn=false;secs=120;clearInterval(timerInt);timerInt=null;
  go(0);
}

function eyebrow(ch,ey){
  return '<div class="eyebrow"><div class="ey-ch">'+ch+'</div><div class="ey-line"></div><div class="ey-lbl">'+ey+'</div></div>';
}
function plate(src,focus,ratio){
  ratio=ratio||'16/9';
  return '<div class="plate" style="aspect-ratio:'+ratio+'">'
    +(src?'<img src="'+src+'" alt="" style="object-position:'+(focus||'center')+'">':'')
    +'<svg width="14" height="14" viewBox="0 0 14 14"><path d="M0 0h6M0 0v6M14 14h-6M14 14v-6" stroke="#7A5E44" stroke-width="1.2"/></svg>'
    +'</div>';
}
function mkOpt(lbl,desc,key,val){
  var sel=S[key]===val;
  return '<button class="opt'+(sel?' sel':'')+'" data-opt="'+key+'" data-val="'+val+'">'
    +'<div class="opt-body">'
    +'<div class="opt-lbl">'+lbl+'</div>'
    +(desc?'<div class="opt-desc">'+desc+'</div>':'')
    +'</div>'
    +'</button>';
}
function mkArrOpt(val,lbl,desc,src,focus,arrKey){
  var sel=S[arrKey].indexOf(val)>-1;
  return '<button class="io'+(sel?' sel':'')+'" data-arr="'+arrKey+'" data-val="'+val+'">'
    +'<div class="plate" style="aspect-ratio:4/3;margin-bottom:0">'
    +(src?'<img src="'+src+'" alt="" style="object-position:'+(focus||'center')+'">':'')
    +'</div>'
    +'<div class="io-cap">'
    +'<div class="io-lbl">'+lbl+(sel?'<div class="io-chk">&#10003;</div>':'')+'</div>'
    +(desc?'<div class="io-desc">'+desc+'</div>':'')
    +'</div></button>';
}
function mkMC(cfg){
  var html='<div class="mc-list">';
  for(var i=0;i<cfg.opts.length;i++){
    var o=cfg.opts[i];
    var val=o[0],lbl=o[1],desc=o[2],score=o[3];
    var sel=S.trig[cfg.key]===val;
    var isHalf=sel&&score===0.5;
    var cls='mc'+(sel?(isHalf?' sel-half':' sel'):'');
    html+='<button class="'+cls+'" data-trig="'+cfg.key+'" data-tval="'+val+'" data-tscore="'+score+'">'
      +'<div class="mc-body">'
      +'<div class="mc-lbl">'+lbl+'</div>'
      +(desc?'<div class="mc-desc">'+desc+'</div>':'')
      +'</div>'
      +'</button>';
  }
  html+='</div>';
  return html;
}

// ============================================
// GA4 EVENT TRACKING FUNCTIONS
// ============================================
function trackGA4Event(eventName, eventParams) {
  eventParams = eventParams || {};
  if (typeof gtag !== 'undefined') { gtag('event', eventName, eventParams); console.log('GA4 Event: ' + eventName, eventParams); }
  else { console.warn('gtag not available, event not sent:', eventName, eventParams); }
}
function trackSensitiveQuizStarted() { trackGA4Event('sensitive_skin_assessment_started', { quiz_name: 'sensitive_analyser' }); }
function trackSensitiveQuizStep(stepName, stepNumber) { trackGA4Event('sensitive_skin_assessment_step_completed', { step_name: stepName, step_number: stepNumber }); }
function trackSensitiveQuizAnswer(questionKey, answerValue) { trackGA4Event('sensitive_skin_assessment_answer_selected', { question: questionKey, answer: answerValue }); }
function trackSensitiveQuizLeadCaptured(isChosen) { trackGA4Event('sensitive_skin_assessment_lead_captured', { is_chosen_customer: isChosen }); }
function trackSensitiveQuizResultViewed(verdict, score, triggerCount) { trackGA4Event('sensitive_skin_assessment_result_viewed', { verdict: verdict, score: score, trigger_count: triggerCount }); }
function trackSensitiveQuizEnded() { trackGA4Event('sensitive_skin_assessment_ended', { quiz_name: 'sensitive_analyser' }); }
function trackSensitiveQuizMetaPixelLead() {
  if (typeof fbq !== 'undefined') {
    fbq('trackCustom', 'lead');
    console.log('Meta Pixel Event: lead');
  } else {
    console.warn('fbq not available, lead event not sent');
  }
}
function trackSensitiveQuizAddToCart() { trackGA4Event('sensitive_skin_assessment_add_to_cart', { product: 'recovery_serum' }); }
function trackSensitiveQuizConsultation(source) { trackGA4Event('sensitive_skin_assessment_consultation_opened', { source: source }); }
function trackSensitiveQuizPdfDownloaded() { trackGA4Event('sensitive_skin_assessment_pdf_downloaded', { quiz_name: 'sensitive_analyser' }); }

// ============================================
// WEBENGAGE EVENT TRACKING
// ============================================
function generateSkinQuizFormId() {
   var rand = Math.floor(10 + Math.random() * 90); // 2-digit random suffix
  return Date.now() + '' + rand; // timestamp + random id, changes every time — kept as string, WebEngage drops oversized numbers
}

function trackWebEngageSkinFormSubmitted(email, name, phone) {
  if (typeof webengage === 'undefined') {
    console.warn('WebEngage not available, skin_form_submitted event not sent');
    return;
  }
  if (phone) {
    webengage.user.login('+91' + phone);
    webengage.user.setAttribute('we_phone', '+91' + phone);
    if (email) webengage.user.setAttribute('we_email', email);
    if (name) webengage.user.setAttribute('we_first_name', name);
  } else if (email) {
    webengage.user.login(email);
    webengage.user.setAttribute('we_email', email);
    if (name) webengage.user.setAttribute('we_first_name', name);
  }

  webengage.user.setAttribute('has_sensetive_quiz', true);

  var activeTriggers = Object.keys(S.trig).filter(function(k) {
    return S.trig[k] && S.trig[k] !== 'none';
  });

  webengage.track('skin_form_submitted', {
    gender:       S.gender || '',
    form_id:      generateSkinQuizFormId(),
    redness:      S.hasRedness || '',
    redness_type: S.rednessType || '',
    triggers:     S.trig,
    otc_creams:   S.otcCreams || '',
    sunscreen:    S.sunscreen || '',
    sleep:        S.sleepQ || '',
    diet:         S.dietQ || '',
    hydration:    S.hydroQ || '',
    score:        calcScore()
  });
  console.log('WebEngage Event: skin_form_submitted');
}

function trackWebEngageConsultationBooked(bookingDateISO, bookingTime) {

  var bookingDateISOS = new Date(bookingDateISO);

  if (typeof webengage === 'undefined') {
    console.warn('WebEngage not available, consultation_booked event not sent');
    return;
  }
  webengage.track('consultation_booked', {
    category:     'Skin Analyser',
    form_id:      generateSkinQuizFormId(), // independent id, same generator as skin_form_submitted
    booking_date: bookingDateISOS, // WebEngage types Date attributes from a Date object, not a string/number
    booking_time: bookingTime
  });
  console.log('WebEngage Event: consultation_booked');
}

document.addEventListener('click',function(e){
  var tr=e.target.closest('[data-trig]');
  if(tr){
    var key=tr.dataset.trig,val=tr.dataset.tval,score=parseFloat(tr.dataset.tscore);
    S.trig[key]=val;S.ts[key]=score;
    trackSensitiveQuizAnswer(key, val);
    setTimeout(advance,360);
    return;
  }
  var op=e.target.closest('[data-opt]');
  if(op){
    var key=op.dataset.opt,val=op.dataset.val;
    S[key]=val;
    trackSensitiveQuizAnswer(key, val);
    if(key==='hasRedness'&&val==='no') S.rednessType=[];
    var id=vis()[curIdx].id;
    if(id!=='rednesstype'&&id!=='chosen'&&id!=='photos') setTimeout(advance,320);
    else go(curIdx,false);
    return;
  }

   var ar=e.target.closest('[data-arr]');
  if(ar){
    var key=ar.dataset.arr,val=ar.dataset.val;
    S[key]=[val];
    trackSensitiveQuizAnswer(key, S[key].join(','));
    var cb=document.getElementById('cont-btn');
    if(cb) cb.disabled=S[key].length===0;
    go(curIdx,false);
    if(S[key].length>0) setTimeout(advance,360);
    return;
  }

  var atcBtn=e.target.closest('[data-atc-trigger]');
  if(atcBtn){
    trackSensitiveQuizAddToCart();
    atcBtn.classList.add('atc-loading');
    setTimeout(function(){atcBtn.classList.remove('atc-loading');},3000);
  }
});

var R={};

R.welcome=function(w){
  w.innerHTML='<div style="display:flex;flex-direction:column;min-height:100%">'
    +'<div style="position:relative;height:240px;overflow:hidden;background:#111;flex-shrink:0">'
    +'<img src="https://cdn.shopify.com/s/files/1/0267/6768/7757/files/Sensitive_Skin_clear.webp?v=1777374261" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:center 28%;display:block">'
    +'<div id="clear-reveal" style="position:absolute;left:0;right:0;bottom:0;height:0;overflow:hidden">'
    +'<img src="https://cdn.shopify.com/s/files/1/0267/6768/7757/files/Sensitive_Skin_red.webp?v=1777374262" style="position:absolute;bottom:0;left:0;width:100%;object-fit:cover;object-position:center 28%;display:block" id="clear-img">'
    +'</div>'
    +'<div id="scan-line" style="position:absolute;left:0;right:0;height:3px;background:linear-gradient(to right,transparent 0%,rgba(255,255,255,0) 5%,rgba(255,255,255,0.9) 40%,rgba(255,255,255,1) 50%,rgba(255,255,255,0.9) 60%,rgba(255,255,255,0) 95%,transparent 100%);top:-3px;box-shadow:0 0 18px 6px rgba(255,255,255,0.35)"></div>'
    +'</div>'
    +'<div style="padding:20px 22px 24px;flex:1">'
    +'<div style="font-family:JetBrains Mono,monospace;font-size:9px;letter-spacing:.22em;color:#D4342A;font-weight:600;text-transform:uppercase;margin-bottom:10px">&#183; A fit assessment &#183;</div>'
    +'<h1 style="font-family:Fraunces,serif;font-size:32px;font-weight:400;line-height:1.05;color:#1A1412;letter-spacing:-.02em;margin:0 0 14px">Is <span style="font-style:italic;color:#D4342A">Re(d)covery</span><br>right for your <span style="font-style:italic">sensitive</span> skin?</h1>'
    +'<p style="font-family:Inter,sans-serif;font-size:13px;line-height:1.65;color:#5B524C;margin:0 0 20px">Eight questions about what your skin reacts to &#8212; finished with a personal assessment and care plan.</p>'
    +'<div style="display:grid;grid-template-columns:1fr 1fr;border-top:1px solid #E8DFD4;border-bottom:1px solid #E8DFD4;padding:12px 0;margin-bottom:20px">'
    +'<div style="text-align:center;border-right:1px solid #E8DFD4">'
    +'<div style="font-family:Fraunces,serif;font-size:22px;font-weight:500;color:#1A1412;line-height:1">02:00</div>'
    +'<div style="font-family:JetBrains Mono,monospace;font-size:9px;letter-spacing:.16em;color:#A89F97;text-transform:uppercase;margin-top:3px">Minutes</div>'
    +'</div>'
    +'<div style="text-align:center">'
    +'<div style="font-family:Fraunces,serif;font-size:22px;font-weight:500;color:#1A1412;line-height:1">16</div>'
    +'<div style="font-family:JetBrains Mono,monospace;font-size:9px;letter-spacing:.16em;color:#A89F97;text-transform:uppercase;margin-top:3px">Questions</div>'
    +'</div></div>'
    +'<button onclick="startTimer();trackSensitiveQuizStarted();advance()" style="width:100%;padding:16px 20px;background:#1A1412;color:#fff;border:none;border-radius:14px;cursor:pointer;font-family:Inter,sans-serif;font-size:15px;font-weight:500;display:flex;align-items:center;justify-content:space-between;margin-bottom:12px">'
    +'<span>Assess my skin now</span><span style="font-family:JetBrains Mono,monospace;opacity:.6;font-size:13px">&#8594;</span></button>'
    +'<div style="font-family:JetBrains Mono,monospace;font-size:9px;letter-spacing:.16em;color:#A89F97;text-align:center;text-transform:uppercase">Private &#183; Personalised &#183; Dermatologist-informed</div>'
    +'</div></div>';
  setTimeout(function(){
    var line=document.getElementById('scan-line');
    var reveal=document.getElementById('clear-reveal');
    var clearImg=document.getElementById('clear-img');
    var hero=line&&line.parentElement;
    if(!line||!reveal||!hero) return;
    var h=hero.offsetHeight||240;
    var pos=-3,speed=0.55,pausing=false,PAUSE=0;
    function updateImgPos(){
      var rh=parseFloat(reveal.style.height)||0;
      clearImg.style.top=-(h-rh)+'px';
      clearImg.style.height=h+'px';
      clearImg.style.width='100%';
      clearImg.style.position='absolute';
      clearImg.style.objectFit='cover';
      clearImg.style.objectPosition='center 28%';
    }
    function step(){
      if(pausing) return;
      pos+=speed;
      if(pos>h+3){
        pausing=true;
        setTimeout(function(){
          pos=-3;line.style.top='-3px';reveal.style.height='0px';
          updateImgPos();pausing=false;requestAnimationFrame(step);
        },PAUSE);
        return;
      }
      line.style.top=pos+'px';
      var revH=Math.max(0,h-pos);
      reveal.style.height=revH+'px';
      updateImgPos();
      requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  },200);
};

R.gender=function(w){
  w.innerHTML='<div class="pad">'+eyebrow('Ch. I','About you')
    +'<div class="qtitle">How do you <em style="color:#D4342A;font-style:italic">identify</em>?</div>'
    +'<div class="qsub">Helps us tailor lifestyle insights in your results.</div>'
    +'<div class="opt-list">'
    +mkOpt('Female','','gender','Female')
    +mkOpt('Male','','gender','Male')
    +'</div></div>';
};

R.redness=function(w){
  w.innerHTML='<div class="pad">'+eyebrow('Ch. III','Redness')
    +'<div class="qtitle">Do you have any <em style="color:#D4342A;font-style:italic">redness</em> on your face?</div>'
    +'<div class="qsub">Could be constant, or something that comes and goes.</div>'
    +plate(I.red_face,'center 30%','16/9')
    +'<div class="opt-list">'
    +mkOpt('Yes, I do have redness','','hasRedness','yes')
    +mkOpt('No, my skin tone is fairly even','','hasRedness','no')
    +'</div></div>';
};

R.rednesstype=function(w){
  w.innerHTML='<div class="pad">'+eyebrow('Ch. III','Redness type')
    +'<div class="qtitle">Which best describes your <em style="color:#D4342A;font-style:italic">redness</em>?</div>'
    +'<div class="qsub">Select all that apply.</div>'
    +'<div class="ig">'
    +mkArrOpt('spots','Post-acne redness','Red marks left behind by breakouts',I.red_spots,'center 30%','rednessType')
    +mkArrOpt('diffuse','Facial flushing','Diffuse redness, rosacea-type',I.red_diffuse,'center','rednessType')
    +'</div></div>';
};

// Trigger screens
for(var ti=0;ti<TC.length;ti++){
  (function(cfg){
    R['trig_'+cfg.key]=function(w){
      w.innerHTML='<div class="pad">'+eyebrow(cfg.ch,cfg.ey)
        +'<div class="qtitle">'+cfg.q+'</div>'
        +'<div class="qsub">'+cfg.sub+'</div>'
        +plate(I[cfg.img],cfg.focus,'16/9')
        +mkMC(cfg)
        +'</div>';
    };
  })(TC[ti]);
}

R.otc=function(w){
  w.innerHTML='<div class="pad">'+eyebrow('Ch. IV','Skincare history')
    +'<div class="qtitle">Have you used <em style="color:#D4342A;font-style:italic">fairness</em>, lightening, or <em style="color:#D4342A;font-style:italic">steroid</em> creams?</div>'
    +'<div class="qsub">Common but consequential &#8212; they change how your skin behaves. No judgement.</div>'
    +'<div style="padding:13px 15px;background:#FAF6F1;border-radius:12px;margin-bottom:20px;border-left:3px solid #D4342A">'
    +'<div style="font-family:JetBrains Mono,monospace;font-size:10px;letter-spacing:.16em;color:#D4342A;text-transform:uppercase;margin-bottom:4px;font-weight:600">&#8212; Includes &#8212;</div>'
    +'<div style="font-family:Inter,sans-serif;font-size:13px;color:#5B524C;line-height:1.5">Hydroquinone, mercury-based creams, any cream labelled &#8220;skin lightening&#8221; or prescribed for a rash that worked a little too well.</div>'
    +'</div>'
    +'<div class="opt-list">'
    +mkOpt('Yes, I have used these','','otcCreams','yes')
    +mkOpt('No, I have not','','otcCreams','no')
    +'</div></div>';
};

R.sunscreen=function(w){
  w.innerHTML='<div class="pad">'+eyebrow('Ch. V','Sun protection')
    +'<div class="qtitle">How often do you <em style="color:#D4342A;font-style:italic">actually</em> wear sunscreen?</div>'
    +'<div class="qsub">The single biggest lever for sensitive skin. Be honest &#8212; we won&#8217;t tell.</div>'
    +'<div class="opt-list">'
    +mkOpt('Every single day','Rain or shine, indoors and out','sunscreen','daily')
    +mkOpt('Only when going outside','Skip on cloudy or indoor days','sunscreen','outdoors')
    +mkOpt('Rarely','Special occasions only','sunscreen','rarely')
    +mkOpt('Honestly, never','Haven\'t built the habit yet','sunscreen','never')
    +'</div></div>';
};

var LIFE={
  sleepQ:{ch:'Ch. VI',ey:'Lifestyle sleep',q:'How is your <em style="color:#D4342A;font-style:italic">sleep</em> these days?',sub:'Your skin does its heaviest repair work while you sleep.',
    opts:[['good','I sleep well most nights','7 to 8 hours, fairly consistent'],['mixed','Hit and miss','Some nights fine, others not'],['poor','I struggle to sleep well','Frequently tired or restless']]},
  dietQ:{ch:'Ch. VI',ey:'Lifestyle diet',q:'How would you describe what you <em style="color:#D4342A;font-style:italic">eat</em>?',sub:'No judgement &#8212; helps us give you relevant lifestyle insights.',
    opts:[['balanced','Fairly balanced','Fruits, vegetables, home-cooked most days'],['mixed','Mix of healthy and processed','Some good days, some not'],['poor','Mostly processed or outside food','Fast food, packaged meals, or skipping']]},
  hydroQ:{ch:'Ch. VI',ey:'Lifestyle hydration',q:'How much <em style="color:#D4342A;font-style:italic">water</em> do you drink in a day?',sub:'Dehydration weakens your barrier and amplifies sensitivity.',
    opts:[['good','8 or more glasses','Well hydrated'],['mid','Around 4 to 7 glasses','Could be better'],['low','Less than 4 glasses','Not enough for your skin']]}
};
['sleepQ','dietQ','hydroQ'].forEach(function(k){
  R[k]=function(w){
    var c=LIFE[k];
    var opts='';
    for(var i=0;i<c.opts.length;i++){
      var o=c.opts[i];
      opts+=mkOpt(o[1],o[2],k,o[0]);
    }
    w.innerHTML='<div class="pad">'+eyebrow(c.ch,c.ey)
      +'<div class="qtitle">'+c.q+'</div>'
      +'<div class="qsub">'+c.sub+'</div>'
      +'<div class="opt-list">'+opts+'</div></div>';
  };
});

R.photos=function(w){
  var slots=[['front','Front'],['right','Right side'],['left','Left side']];
  var shtml='';
  for(var i=0;i<slots.length;i++){
    var key=slots[i][0],lbl=slots[i][1];
    var photo=S.photos[key],st=S.ps[key];
    var cls='up-slot'+(st==='checking'?' checking':st==='verified'?' verified':st==='rejected'?' rejected':'');
    var stxt=st==='checking'?'Checking\u2026':st==='rejected'?'Please upload a photo showing your face':st==='verified'?'Photo added \u2713':'Tap to upload';
    shtml+='<label class="'+cls+'" id="slot-'+key+'">'
      +'<div class="up-thumb">'+(photo?'<img src="'+photo+'" alt="">':'<div style="position:absolute;inset:0;display:grid;place-items:center;font-family:JetBrains Mono,monospace;font-size:10px;color:#A89F97">'+lbl.split(' ')[0].toUpperCase()+'</div>')+'</div>'
      +'<div style="flex:1;min-width:0"><div class="up-lbl">'+lbl+'</div><div class="up-status">'+stxt+'</div></div>'
      +(photo
        ?'<button type="button" onclick="event.preventDefault();S.photos[\''+key+'\']=null;S.ps[\''+key+'\']=null;go(curIdx,false)" style="padding:6px 10px;background:transparent;border:1px solid #E8DFD4;border-radius:8px;font-family:JetBrains Mono,monospace;font-size:9px;letter-spacing:.12em;color:#5B524C;text-transform:uppercase;cursor:pointer;flex-shrink:0">Remove</button>'
        :'<div style="display:flex;gap:8px;flex-shrink:0">'
        +'<button type="button" onclick="event.preventDefault();openCamera(\''+key+'\')" style="padding:7px 11px;background:#D4342A;color:#fff;border:none;border-radius:8px;font-family:JetBrains Mono,monospace;font-size:9px;letter-spacing:.12em;text-transform:uppercase;font-weight:600;cursor:pointer">Capture</button>'
        +'<button type="button" onclick="event.preventDefault();openUpload(\''+key+'\')" style="padding:7px 11px;background:#1A1412;color:#fff;border:none;border-radius:8px;font-family:JetBrains Mono,monospace;font-size:9px;letter-spacing:.12em;text-transform:uppercase;font-weight:600;cursor:pointer">Upload</button>'
        +'</div>')
      +'<input id="upload-'+key+'" type="file" accept="image/*" style="display:none" onchange="handlePhoto(\''+key+'\',this)">'
      +'</label>';
  }
  w.innerHTML='<div style="padding:28px 22px 24px">'+eyebrow('Ch. VII','Photos optional')
    +'<div style="display:inline-flex;align-items:center;gap:8px;padding:7px 13px 7px 11px;background:#FDF5F3;border:1.5px solid #FBEAE7;border-radius:22px;margin-bottom:16px">'
    +'<span style="width:7px;height:7px;border-radius:50%;background:#D4342A;display:inline-block"></span>'
    +'<span style="font-family:JetBrains Mono,monospace;font-size:11px;letter-spacing:.12em;color:#D4342A;font-weight:700;text-transform:uppercase">Optional step</span></div>'
    +'<div class="qtitle">Upload your photos.</div>'
    +'<div class="qsub">Front and both side profiles help us understand your skin better.</div>'
    +'<div style="display:flex;flex-direction:column;gap:10px;margin-bottom:20px">'+shtml+'</div>'
    +'<button onclick="advance()" style="width:100%;padding:16px 20px;background:#1A1412;color:#fff;border:none;border-radius:12px;cursor:pointer;font-family:Inter,sans-serif;font-size:15px;font-weight:500;display:flex;align-items:center;justify-content:space-between;margin-bottom:10px">'
    +'<span>Continue</span><span style="font-family:JetBrains Mono,monospace;opacity:.6;font-size:13px">&#8594;</span></button>'
    +'<button onclick="advance()" style="width:100%;padding:11px;background:transparent;color:#A89F97;border:none;cursor:pointer;font-family:JetBrains Mono,monospace;font-size:11px;letter-spacing:.12em;text-transform:uppercase">Skip &#8212; no photos</button>'
    +'</div>';
};

function handlePhoto(key,input){
  var file=input.files[0];if(!file)return;
  var reader=new FileReader();
  reader.onload=function(e){
    S.photos[key]=e.target.result;
    var b64=e.target.result.split(',')[1];
    var mime=file.type||'image/jpeg';
    S.ps[key]='checking';
    go(curIdx,false);
    fetch('https://api.anthropic.com/v1/messages',{
      method:'POST',
      headers:{'Content-Type':'application/json','anthropic-version':'2023-06-01','anthropic-dangerous-direct-browser-access':'true'},
      body:JSON.stringify({model:'claude-haiku-4-5-20251001',max_tokens:5,messages:[{role:'user',content:[
        {type:'image',source:{type:'base64',media_type:mime,data:b64}},
        {type:'text',text:'Is this a photo of a human face or facial skin? YES or NO. Accept: front face, side profile, selfie, group photo, face with accessories, close-up of facial skin like cheek nose forehead chin around the mouth. Reject if it shows non-face body skin, objects, animals, food, or landscapes with no face. Reply YES or NO only.'}
      ]}]})
    }).then(function(r){return r.json();}).then(function(d){
      var ans=(d.content&&d.content[0]&&d.content[0].text||'YES').trim().toUpperCase();
      S.ps[key]=(ans.indexOf('NO')===0)?'rejected':'verified';
      go(curIdx,false);
    }).catch(function(){S.ps[key]='verified';go(curIdx,false);});
  };
  reader.readAsDataURL(file);
}

R.chosen=function(w){
  var code=S.isChosen==='yes'?'RENEW12':S.isChosen==='no'?'WELCOME10':null;
  var codeBox='';
  if(code){
    codeBox='<div style="padding:18px;background:#FAF6F1;border-radius:14px;border:1px solid #E8DFD4;margin-bottom:18px">'
      +'<div style="font-family:JetBrains Mono,monospace;font-size:10px;letter-spacing:.18em;color:#D4342A;text-transform:uppercase;margin-bottom:10px;font-weight:600">'+(S.isChosen==='yes'?'&#8212; Renewal offer &#8212;':'&#8212; First-order offer &#8212;')+'</div>'
      +'<div style="font-family:Fraunces,serif;font-size:22px;font-weight:500;color:#1A1412;margin-bottom:12px">'+(S.isChosen==='yes'?'12% off your next order':'10% off your first order')+'</div>'
      +'<div style="display:flex;align-items:center;gap:10px;padding:10px 14px;background:#fff;border:1.5px dashed #D4342A;border-radius:10px">'
      +'<div style="font-family:JetBrains Mono,monospace;font-size:15px;font-weight:600;color:#D4342A;letter-spacing:.14em;flex:1">'+code+'</div>'
      +'<button id="copy-btn" onclick="copyCode(\''+code+'\')" style="padding:6px 12px;background:#1A1412;color:#fff;border:none;border-radius:6px;font-family:Inter,sans-serif;font-size:11px;font-weight:500;cursor:pointer;min-width:62px;text-align:center">COPY</button>'
      +'</div></div>';
  }
  var nextBtn=S.isChosen
    ?'<button onclick="advance()" style="width:100%;padding:17px 20px;background:#D4342A;color:#fff;border:none;border-radius:14px;cursor:pointer;font-family:Inter,sans-serif;font-size:15px;font-weight:500;display:flex;align-items:center;justify-content:space-between"><span>See my skin profile</span><span style="font-family:JetBrains Mono,monospace;opacity:.7">&#8594;</span></button>'
    :'';
  w.innerHTML='<div class="pad">'+eyebrow('Ch. VIII','A small thank-you')
    +'<div class="qtitle">Are you already part of <em style="color:#D4342A;font-style:italic">CHOSEN</em>?</div>'
    +'<div class="qsub">We have a little something waiting either way.</div>'
    +'<div class="opt-list" style="margin-bottom:18px">'
    +mkOpt('Yes, I\'m a CHOSEN customer','Welcome back','isChosen','yes')
    +mkOpt('I\'m new to CHOSEN','Great to have you with us','isChosen','no')
    +'</div>'+codeBox+nextBtn+'</div>';
};

function copyCode(code){
  try{navigator.clipboard.writeText(code).catch(function(){});}catch(e){}
  var btn=document.getElementById('copy-btn');
  if(btn){btn.textContent='COPIED';btn.style.background='#1F7A3F';setTimeout(function(){btn.textContent='COPY';btn.style.background='#1A1412';},2000);}
}

R.result=function(w){
  var score=calcScore();
  var isFit=score>=2;
  var tkeys=Object.keys(S.trig);
  var trigCount=0;
  for(var i=0;i<tkeys.length;i++){if(S.trig[tkeys[i]]&&S.trig[tkeys[i]]!=='none')trigCount++;}
  var hasRed=S.hasRedness==='yes';
  var hasOtc=S.otcCreams==='yes';
  var hasDiff=S.rednessType.indexOf('diffuse')>-1;
  var hasSpots=S.rednessType.indexOf('spots')>-1;
  var hStress=S.trig.stress&&S.trig.stress!=='none';
  var hPoll=S.trig.pollution&&S.trig.pollution!=='none';
  var ringTarget=isFit?(score>=4?1:score>=2.5?0.75:0.5):0.22;
  var ringFull=2*Math.PI*70;
  var C2=2*Math.PI*19;
  var verdict=isFit?(score>=4?'Perfect fit':'Good fit'):'Not a fit';
  trackSensitiveQuizEnded();
  trackSensitiveQuizMetaPixelLead();
  trackSensitiveQuizResultViewed(verdict, score, trigCount);

  var howRows=[];
  if(isFit){
    howRows.push({l:'For your sensitive skin',c:'Re(d)covery is built around tranexamic acid &#8212; oil-free and formulated for reactive and sensitive skin. It may help calm the skin barrier, reduce reactivity over time, and support your skin\'s tolerance to other products.'});
    if(hasRed){
      var rc='Tranexamic acid acts on vascular components to reduce redness and flushing. ';
      if(hasDiff&&hasSpots) rc+='Both the diffuse flushing and post-acne redness may improve with consistent nightly use &#8212; results are typically visible within 4&#8211;6 weeks.';
      else if(hasDiff) rc+='For diffuse flushing or rosacea-type redness, improvement may begin within a few weeks of consistent nightly use.';
      else if(hasSpots) rc+='For post-acne redness, tranexamic acid may reduce residual erythema and help even out the skin tone in previously affected areas.';
      howRows.push({l:'For your redness',c:rc});
    }
  }

  // Tips
  var tips=[];
  if(isFit){
    tips.push(['01','Apply 1 to 2 pumps on a clean dry face and neck at bedtime. Leave overnight and cleanse off in the morning. If you are new to actives, start with 2 hours and build up gradually.']);
    tips.push(['02','Follow with a broad-spectrum sunscreen every morning. Sun exposure is one of the leading triggers for sensitive and reactive skin.']);
    if(hasDiff) tips.push(['03','For intense diffuse redness, you may also use Re(d)covery for up to 2 hours in the morning before cleansing.']);
    tips.push([String(tips.length+1).length<2?'0'+String(tips.length+1):String(tips.length+1),'Give it at least 4 to 6 weeks of consistent use before evaluating. Re(d)covery is safe for up to 12 weeks of use.']);
  }

  // Sunscreen
  var sunMap={daily:{good:true,lbl:'Good sun habits',copy:'Daily sunscreen is one of the most effective steps for sensitive skin. Keep it up.'},outdoors:{good:false,lbl:'Boost your sun protection',copy:'UV radiation penetrates clouds and glass. Daily application, even indoors, meaningfully supports sensitive skin.'},rarely:{good:false,lbl:'Sunscreen every day',copy:'Infrequent sunscreen use allows UV to worsen sensitivity and redness. A daily habit would significantly support your skin.'},never:{good:false,lbl:'Start with sunscreen',copy:'UV exposure is among the most common triggers for sensitive skin. Starting a daily sunscreen habit is one of the most impactful steps you can take.'}};
  var sun=S.sunscreen?sunMap[S.sunscreen]:null;

  // Lifestyle
  var liCards=[];
  var strongTrig=0;
  var stkeys=Object.keys(S.trig);
  for(var si=0;si<stkeys.length;si++){var v=S.trig[stkeys[si]];if(v==='mod'||v==='sev')strongTrig++;}

  if(trigCount>=2||S.sleepQ==='mixed'||S.sleepQ==='poor'){
    var sd=S.sleepQ==='poor'?'Prioritise 7 to 8 hours of sleep. Avoid screens and caffeine in the 2 hours before bed. Your skin does its heaviest repair work overnight.':'Even small improvements like a consistent bedtime and less screen time at night can make a real difference.';
    liCards.push({tag:'Sleep',title:'Your skin repairs while you rest',why:'During deep sleep, growth hormones repair the skin barrier. Poor sleep raises cortisol levels, increasing inflammation and making skin more reactive.',doText:sd});
  }
  if(hStress||strongTrig>=2){
    liCards.push({tag:'Stress',title:'Cortisol is on your skin',why:'Stress raises cortisol, which compromises the skin barrier. This allows irritants in and moisture out, This makes skin more reactive to products, temperature, and touch.',doText:'Brief daily stress relief, whether a walk, breathing exercises or music, lowers cortisol measurably. Stress management is part of your skincare.'});
  }
  if(hPoll){
    liCards.push({tag:'Pollution',title:'What the city leaves behind',why:'Pollutant particles from traffic and dust penetrate the skin and trigger oxidative stress, breaking down the barrier and increasing sensitivity.',doText:'Double cleanse in the evening to remove accumulated pollutants. Antioxidant-rich foods like amla, tomatoes and berries help neutralise oxidative damage from within.'});
  }
  if(S.dietQ==='balanced'){
    liCards.push({tag:'Diet',title:'You are already doing the work',good:true,why:'A balanced diet supports skin repair, barrier function, and inflammation control.',doText:'To go further: amla, tomatoes, berries, and green leafy vegetables daily. Omega-3s from fish, flaxseed or walnuts a few times a week actively reduce skin inflammation.'});
  } else if(trigCount>=1||S.dietQ==='mixed'||S.dietQ==='poor'){
    var dd=S.dietQ==='poor'?'Start with one swap. Replace one processed meal with home-cooked food. Include omega-3s from fish, flaxseed or walnuts and add colourful vegetables where you can.':'Include amla, tomatoes, berries, and leafy greens daily. Omega-3s from fish, flaxseed, and walnuts actively reduce skin inflammation.';
    liCards.push({tag:'Diet',title:'Calm the fire from inside',why:'Omega-3 fatty acids reduce skin inflammation, antioxidants protect the barrier, and high-glycemic foods do the opposite.',doText:dd});
  }
  var hd=S.hydroQ==='low'?'Start with 6 glasses a day and build up. Avoid very hot showers and prolonged air conditioning.':S.hydroQ==='mid'?'You are almost there. Aim for 8 to 10 glasses a day. Keep a bottle at your desk.':'Aim for 8&#8211;10 glasses consistently through the day.';
  var hgood=S.hydroQ==='good';
  liCards.push({tag:'Hydration',title:hgood?'Good hydration habit':'Your barrier is thirsty',good:hgood,why:'Dehydration reduces the skin barrier\'s function, making it more permeable to irritants and more prone to sensitivity, dryness, and redness.',doText:hd});

  // Trigger graph data
  var trigData=[
    {key:'cosmetics',label:'Cosmetics',pct:57.8},
    {key:'sun',label:'Sun exposure',pct:60.8},
    {key:'heat',label:'Weather changes',pct:65.7},
    {key:'stress',label:'Stress',pct:60.8},
    {key:'pollution',label:'Pollution',pct:22.5},
    {key:'exercise',label:'Exercise',pct:48.0},
    {key:'water',label:'Water contact',pct:5.9}
  ];
  var mineArr=[];
  for(var ti=0;ti<trigData.length;ti++){
    var tk=trigData[ti].key;
    if(S.trig[tk]&&S.trig[tk]!=='none') mineArr.push(trigData[ti]);
  }

  var h='<div style="padding-bottom:80px">';

  // Hero
  h+='<div style="position:relative;padding:40px 22px 36px;background:'+(isFit?'linear-gradient(180deg,#FAF6F1 0%,#FBEAE7 100%)':'linear-gradient(180deg,#F8F5F0 0%,#EDE4D6 100%)')+';overflow:hidden">';
  h+='<svg width="12" height="12" viewBox="0 0 12 12" style="position:absolute;top:14px;left:14px"><path d="M0 0h6M0 0v6" stroke="'+(isFit?'#D4342A':'#A89F97')+'" stroke-width="1.2"/></svg>';
  h+='<svg width="12" height="12" viewBox="0 0 12 12" style="position:absolute;top:14px;right:14px"><path d="M12 0h-6M12 0v6" stroke="'+(isFit?'#D4342A':'#A89F97')+'" stroke-width="1.2"/></svg>';
  h+='<div style="text-align:center">';
  h+='<div style="font-family:JetBrains Mono,monospace;font-size:10px;letter-spacing:.28em;color:'+(isFit?'#D4342A':'#A89F97')+';font-weight:600;text-transform:uppercase;margin-bottom:18px">&#8212; Your skin profile &#8212;</div>';
  h+='<div style="position:relative;display:inline-block;margin-bottom:24px">';
  h+='<svg width="160" height="160" viewBox="0 0 160 160"><circle cx="80" cy="80" r="70" stroke="#E8DFD4" stroke-width="1.5" fill="none"/>';
  h+='<circle id="ring-arc" cx="80" cy="80" r="70" stroke="'+(isFit?'#D4342A':'#A89F97')+'" stroke-width="2.5" fill="none" stroke-dasharray="'+ringFull+'" stroke-dashoffset="'+ringFull+'" stroke-linecap="round" transform="rotate(-90 80 80)" style="transition:stroke-dashoffset 1.4s cubic-bezier(.4,0,.2,1)"/>';
  h+='<g transform="rotate(0 80 80)"><line x1="80" y1="10" x2="80" y2="15" stroke="'+(isFit?'#D4342A':'#A89F97')+'" stroke-width="1.5"/></g>';
  h+='<g transform="rotate(90 80 80)"><line x1="80" y1="10" x2="80" y2="15" stroke="'+(isFit?'#D4342A':'#A89F97')+'" stroke-width="1.5"/></g>';
  h+='<g transform="rotate(180 80 80)"><line x1="80" y1="10" x2="80" y2="15" stroke="'+(isFit?'#D4342A':'#A89F97')+'" stroke-width="1.5"/></g>';
  h+='<g transform="rotate(270 80 80)"><line x1="80" y1="10" x2="80" y2="15" stroke="'+(isFit?'#D4342A':'#A89F97')+'" stroke-width="1.5"/></g>';
  h+='</svg>';
  h+='<div style="position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:0 20px;text-align:center">';
  h+='<div style="font-family:JetBrains Mono,monospace;font-size:9px;letter-spacing:.22em;color:#A89F97;margin-bottom:8px;text-transform:uppercase">&#8212; Your result &#8212;</div>';
  h+='<div style="font-family:Fraunces,serif;font-size:'+(isFit?'24':'20')+'px;font-weight:500;font-style:italic;color:'+(isFit?'#D4342A':'#1A1412')+';line-height:1.05;letter-spacing:-.015em">'+verdict+'</div>';
  h+='<div style="width:20px;height:1px;background:#E8DFD4;margin:8px 0 6px"></div>';
  h+='<div style="font-family:JetBrains Mono,monospace;font-size:8px;letter-spacing:.2em;color:#A89F97;text-transform:uppercase">'+mineArr.length+' of 7 triggers</div>';
  h+='</div></div>';
  h+='<h1 style="font-family:Fraunces,serif;font-size:27px;font-weight:400;line-height:1.1;color:#1A1412;letter-spacing:-.015em;margin:0 0 10px">';
  if(isFit) h+='Your skin shows signs of <em style="font-style:italic;color:#D4342A">sensitivity</em> &#8212; Re(d)covery is built for this';
  else h+='Your skin looks <em style="font-style:italic;color:#1A1412">resilient</em> &#8212; Re(d)covery may not be the right match right now';
  h+='</h1>';
  h+='<p style="font-family:Inter,sans-serif;font-size:13px;color:#5B524C;line-height:1.6;margin:0 auto;max-width:310px">';
  if(isFit) h+=trigCount+' trigger'+(trigCount===1?'':'s')+' identified'+(hasRed?', redness present':'')+'. Here is what that means for your skin.';
  else h+='Based on your answers, your skin does not show the sensitivity markers Re(d)covery targets. That is actually good news.';
  h+='</p></div></div>';

  // Not a fit card
  if(!isFit){
    h+='<div class="sec"><div style="background:#FAF6F1;border:1px solid #E8DFD4;border-radius:16px;padding:22px">';
    h+='<div style="font-family:JetBrains Mono,monospace;font-size:10px;letter-spacing:.2em;color:#A89F97;font-weight:600;text-transform:uppercase;margin-bottom:12px">&#8212; What this means &#8212;</div>';
    h+='<div style="font-family:Fraunces,serif;font-size:22px;font-weight:400;color:#1A1412;margin-bottom:12px">Your skin does not need Re(d)covery right now.</div>';
    h+='<div style="font-family:Inter,sans-serif;font-size:13px;color:#5B524C;line-height:1.65;margin-bottom:12px">Re(d)covery is specifically formulated for reactive, sensitive skin that struggles with products, weather, stress, or redness. Yours seems to be managing well. Using an active serum when your skin does not call for it is unnecessary.</div>';
    h+='<div style="font-family:Inter,sans-serif;font-size:13px;color:#5B524C;line-height:1.65;margin-bottom:18px">If your skin changes &#8212; or if you start noticing more reactivity &#8212; come back and take the assessment again.</div>';
    h+='<button onclick="openBk(\'specialist\')" class="btn-valet" style="background:none;border:none;cursor:pointer;font-family:Inter,sans-serif;font-size:14px;color:var(--ac);font-weight:500;padding:0;display:inline-flex;align-items:center;gap:4px">Speak to a skin specialist &#8594;</button>';
    h+='</div></div>';
  }

  // Concern banner (steroid use / severe grade)
  if(isFit&&hasOtc){
    h+='<div class="sec"><div class="derm"><div class="derm-badge">Please read</div>';
    h+='<div class="derm-h">A dermatologist check is recommended.</div>';
    h+='<div class="derm-p">You mentioned prior use of fairness or steroid creams. Before starting any new skincare active, it is worth speaking with a specialist first.</div>';
    h+='<button onclick="openBk(\'specialist\')" style="margin-top:4px;width:100%;padding:13px 18px;background:#1A1412;color:#fff;border:none;border-radius:12px;cursor:pointer;font-family:Inter,sans-serif;font-size:14px;font-weight:500;display:flex;align-items:center;justify-content:space-between"><span>Speak to a skin specialist</span><span>&#8594;</span></button>';
    h+='</div></div>';
  } else if(isFit&&score>=4){
    h+='<div class="sec"><div class="derm"><div class="derm-badge">Please read</div>';
    h+='<div class="derm-h">Your skin shows strong sensitivity markers.</div>';
    h+='<div class="derm-p">With your level of skin reactivity, speaking with a skin specialist before starting any new active is a good idea.</div>';
    h+='<button onclick="openBk(\'specialist\')" style="margin-top:4px;width:100%;padding:13px 18px;background:#1A1412;color:#fff;border:none;border-radius:12px;cursor:pointer;font-family:Inter,sans-serif;font-size:14px;font-weight:500;display:flex;align-items:center;justify-content:space-between"><span>Speak to a skin specialist</span><span>&#8594;</span></button>';
    h+='</div></div>';
  }

  // How it works
  if(isFit&&howRows.length>0){
    h+='<div class="sec">'+eyebrow('&sect; I','How it works for you');
    h+='<div class="sec-h">A serum that meets your skin <em style="color:#D4342A;font-style:italic">where it is</em>.</div>';
    h+='<div class="how-card">';
    for(var hi=0;hi<howRows.length;hi++){
      var r=howRows[hi];
      h+='<div class="how-row" style="'+(hi===howRows.length-1?'padding-bottom:0;margin-bottom:0;border-bottom:none':'')+'"><div class="how-lbl">'+r.l+'</div><div class="how-copy">'+r.c+'</div></div>';
    }
    h+='</div></div>';
  }

  // Routine
  if(isFit&&tips.length>0){
    h+='<div class="sec">'+eyebrow('&sect; II','Your routine');
    h+='<div class="sec-h">How to use Re(d)covery <em style="color:#D4342A;font-style:italic">right</em>.</div>';
    for(var ri=0;ri<tips.length;ri++){
      h+='<div class="tip"><div class="tip-n">'+tips[ri][0]+'</div><div class="tip-t">'+tips[ri][1]+'</div></div>';
    }
  }

  // Sunscreen
  if(sun){
    h+='<div class="sec"><div class="sun-card '+(sun.good?'sun-good':'sun-warn')+'">';
    h+='<svg width="40" height="40" viewBox="0 0 44 44" style="flex-shrink:0"><circle cx="22" cy="22" r="8" fill="none" stroke="'+(sun.good?'#2D6A4F':'#D4342A')+'" stroke-width="1.8"/>';
    for(var si2=0;si2<8;si2++){
      h+='<line x1="22" y1="6" x2="22" y2="11" stroke="'+(sun.good?'#2D6A4F':'#D4342A')+'" stroke-width="1.8" stroke-linecap="round" transform="rotate('+(si2*45)+' 22 22)"/>';
    }
    h+='</svg><div><div class="sun-lbl" style="color:'+(sun.good?'#2D6A4F':'#D4342A')+'">&#8212; Sun protection &#8212;</div><div class="sun-title">'+sun.lbl+'</div><div class="sun-copy">'+sun.copy+'</div></div></div></div>';
  }

  // Trigger graph
  if(mineArr.length>0){
    h+='<div class="sec">'+eyebrow('&sect; III','Your sensitivity signature');
    h+='<div class="sec-h">What your skin <em style="color:#D4342A;font-style:italic">reacts to</em>.</div>';
    h+='<p style="font-family:Inter,sans-serif;font-size:12px;color:#A89F97;line-height:1.5;margin:0 0 16px">Each circle shows how common that trigger is among people with confirmed sensitive skin.</p>';
    h+='<div class="trig-mine">';
    h+='<div style="display:flex;justify-content:space-between;align-items:baseline;margin-bottom:16px">';
    h+='<div style="font-family:JetBrains Mono,monospace;font-size:10px;letter-spacing:.22em;color:#D4342A;font-weight:600;text-transform:uppercase">&#8212; Yours &#8212;</div>';
    h+='<div style="font-family:Fraunces,serif;font-size:26px;color:#D4342A;font-style:italic;font-weight:500;line-height:1">'+mineArr.length+'<span style="font-family:JetBrains Mono,monospace;font-size:10px;color:#5B524C;font-style:normal;letter-spacing:.12em;margin-left:6px">/7</span></div>';
    h+='</div>';
    for(var gi=0;gi<mineArr.length;gi++){
      var trig=mineArr[gi];
      h+='<div class="trig-row">';
      h+='<div style="position:relative;width:46px;height:46px;flex-shrink:0">';
      h+='<svg width="46" height="46" viewBox="0 0 46 46"><circle cx="23" cy="23" r="19" stroke="#E8DFD4" stroke-width="2" fill="none"/>';
      h+='<circle cx="23" cy="23" r="19" stroke="#D4342A" stroke-width="2.6" fill="none" stroke-dasharray="'+C2+'" stroke-dashoffset="'+(C2*(1-trig.pct/100))+'" stroke-linecap="round" transform="rotate(-90 23 23)"/></svg>';
      h+='<div style="position:absolute;inset:0;display:grid;place-items:center;font-family:JetBrains Mono,monospace;font-size:9px;font-weight:600;color:#1A1412">'+Math.round(trig.pct/10)+'/10</div>';
      h+='</div>';
      h+='<div style="flex:1"><div class="trig-name">'+trig.label+'</div><div class="trig-sub">'+Math.round(trig.pct/10)+' in 10 people with sensitive skin react to this</div></div>';
      h+='<div class="you-badge">YOU</div></div>';
    }
    h+='</div>';
    h+='<div style="font-family:JetBrains Mono,monospace;font-size:8px;letter-spacing:.14em;color:#A89F97;margin-top:12px;text-transform:uppercase;text-align:right">Source &#183; Corazza et al., J Cosmet Dermatol 2022</div>';
    h+='</div>';
  }

  // Lifestyle
  if(liCards.length>0){
    h+='<div class="sec">'+eyebrow('&sect; IV','Lifestyle for your skin');
    h+='<div class="sec-h">The things outside the <em style="color:#D4342A;font-style:italic">bottle</em>.</div>';
    for(var li=0;li<liCards.length;li++){
      var lc=liCards[li];
      h+='<div class="li-card'+(lc.good?' good':'')+'"><div class="li-tag">&#8212; '+lc.tag+' &#8212;</div>';
      h+='<div class="li-title">'+lc.title+'</div>';
      if(lc.why) h+='<div class="li-body"><strong style="color:#1A1412;font-weight:500">Why it matters &#8212; </strong>'+lc.why+'</div>';
      h+='<div class="li-body" style="margin-top:'+(lc.why?'8':'0')+'px"><span class="li-body-do">'+(lc.good?'Go further &#8212; ':'What to do &#8212; ')+'</span>'+lc.doText+'</div></div>';
    }
    h+='</div>';
  }

  // Before & After
  if(isFit){
    h+='<div class="sec">';
    h+=eyebrow('&sect; V','Before &amp; After');
    h+='<div class="sec-h">What consistent use <em style="color:#D4342A;font-style:italic">looks like</em>.</div>';
    h+='<p style="font-family:Inter,sans-serif;font-size:13px;color:#5B524C;line-height:1.6;margin:0 0 18px">1 week of nightly use. Same lighting, same angle.</p>';
    h+='<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px">';
    h+='<div style="border-radius:14px;overflow:hidden;border:1px solid #E8DFD4"><div style="aspect-ratio:4/5;position:relative;overflow:hidden;display:flex;align-items:flex-end;background:#111">';
    h+='<img src="https://cdn.shopify.com/s/files/1/0267/6768/7757/files/before-senstive.webp?v=1777376942" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:center;filter:contrast(1.4) saturate(1.35) brightness(0.95)"><div style="width:100%;padding:10px 12px;background:rgba(26,20,18,.55);backdrop-filter:blur(4px)">';
    h+='<div style="font-family:JetBrains Mono,monospace;font-size:9px;letter-spacing:.16em;color:rgba(255,255,255,.7);text-transform:uppercase">Before</div>';
    h+='<div style="font-family:Fraunces,serif;font-size:13px;color:#fff;font-style:italic;margin-top:2px">Week 0</div>';
    h+='</div></div></div>';
    h+='<div style="border-radius:14px;overflow:hidden;border:1px solid #E8DFD4"><div style="aspect-ratio:4/5;position:relative;overflow:hidden;display:flex;align-items:flex-end;background:#111">';
    h+='<img src="https://cdn.shopify.com/s/files/1/0267/6768/7757/files/after-senstive.webp?v=1777376942" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:center;filter:contrast(1.4) saturate(1.35) brightness(0.95)"><div style="width:100%;padding:10px 12px;background:rgba(26,20,18,.55);backdrop-filter:blur(4px)">';
    h+='<div style="font-family:JetBrains Mono,monospace;font-size:9px;letter-spacing:.16em;color:rgba(255,255,255,.7);text-transform:uppercase">After</div>';
    h+='<div style="font-family:Fraunces,serif;font-size:13px;color:#fff;font-style:italic;margin-top:2px">Week 1</div>';
    h+='</div></div></div>';
    h+='</div></div>';
  }

  // CTA section
  h+='<div class="sec" style="padding-bottom:0">';
  if(isFit){
    h+='<div class="cta-dark">';
    h+='<div style="position:absolute;top:0;right:0;bottom:0;width:100px;opacity:.15;background:radial-gradient(circle at 100% 50%,#D4342A 0%,transparent 70%)"></div>';
    h+='<div style="font-family:JetBrains Mono,monospace;font-size:10px;letter-spacing:.22em;color:#D4342A;font-weight:600;text-transform:uppercase;margin-bottom:14px;position:relative">&#8212; Begin your Re(d)covery &#8212;</div>';
    h+='<div style="font-family:Fraunces,serif;font-size:26px;font-weight:400;line-height:1.15;margin:0 0 12px;letter-spacing:-.01em;position:relative">Shall we start <em style="font-style:italic;color:#F5B5AD">tonight</em>?</div>';
    h+='<p style="font-family:Inter,sans-serif;font-size:13px;line-height:1.6;opacity:.8;margin:0 0 18px;position:relative">Consistent nightly use is the thing. 4&#8211;6 weeks to begin noticing. 12 weeks to see your skin settle.</p>';
    h+='<div style="display:flex;justify-content:center;gap:8px;margin-bottom:20px;flex-wrap:wrap;position:relative">';
    var pills=['From 7 days','Best at 6 weeks','30 ml nightly'];
    for(var pi=0;pi<pills.length;pi++) h+='<span style="font-family:JetBrains Mono,monospace;font-size:9px;letter-spacing:.12em;padding:5px 9px;border-radius:12px;background:rgba(255,255,255,.08);border:1px solid rgba(255,255,255,.12);text-transform:uppercase">'+pills[pi]+'</span>';
    h+='</div>';
    h+='<form method="post" action="/cart/add" class="quick__form" enctype="multipart/form-data" data-product-form data-quickbuy-form>';
    h+='<input type="hidden" name="form_type" value="product">';
    h+='<input type="hidden" name="utf8" value="✓">';
    h+='<input type="hidden" name="id" value="'+RECOVERY_VID+'">';
    h+='<button type="submit" name="add" class="btn-red" style="width:100%;border:none;cursor:pointer" data-add-to-cart data-atc-trigger>';
    h+='<span>Add Re(d)covery to cart</span>';
    h+='<span style="font-family:JetBrains Mono,monospace;opacity:.7">&#8594;</span>';
    h+='</button>';
    h+='</form>';
    h+='</div>';
  } else {
    // "Not the right fit" card - removed "Speak to a skin specialist" button as per updated design
    // The consultation booking link will be available below in the "Have more questions?" section
    h+='<div style="background:#FAF6F1;border:1px solid #E8DFD4;border-radius:14px;padding:20px;text-align:center">';
    h+='<div style="font-family:Fraunces,serif;font-size:20px;font-weight:400;color:#1A1412;margin-bottom:10px">Not the right fit &#8212; <em style="font-style:italic">for now</em>.</div>';
    h+='<div style="font-family:Inter,sans-serif;font-size:13px;color:#5B524C;line-height:1.65;margin-bottom:16px">Re(d)covery is built for reactive, sensitive skin. If your skin changes or you start noticing more reactivity, come back and reassess.</div>';
    h+='</div>';
  }

  // Have more questions + retake
  // Book consultation button - opens booking calendar for users to schedule their free consultation
  h+='<div style="padding:0 22px 16px"><div style="font-family:Inter,sans-serif;font-size:13px;color:#5B524C;text-align:center;margin-bottom:14px;margin-top:4px">Have more questions?</div>'
    +'<button onclick="openBk(\'consultation\')" style="width:100%;padding:16px 20px;background:#D4342A;color:#fff;border:none;border-radius:14px;cursor:pointer;font-family:Inter,sans-serif;font-size:15px;font-weight:600;display:flex;align-items:center;justify-content:space-between;box-shadow:0 4px 14px rgba(212,52,42,0.25)"><span>Book your free consultation</span><span style="font-family:JetBrains Mono,monospace;font-size:13px">&#8594;</span></button>'
    +'</div>';

  // "Build your routine" button - opens formulation filter popup for personalized product recommendations
  // This uses the same popup as the diagnostic page routine builder
  if(!isFit) {
    h+='<div style="padding:0 22px 16px;margin-top:-8px">'
      +'<button data-open-routine-builder style="width:100%;padding:14px 20px;background:#1A1412;color:#fff;border:none;border-radius:12px;cursor:pointer;font-family:Inter,sans-serif;font-size:14px;font-weight:500;display:flex;align-items:center;justify-content:space-between"><span>Build your routine</span><span style="font-family:JetBrains Mono,monospace;opacity:.7;font-size:13px">&#8594;</span></button>'
      +'</div>';
  }

  h+='<button onclick="restart()" class="btn-ghost">Retake assessment</button>';
  h+='</div></div>';

  // Save quiz data to sheet before results are rendered — with userId, empty personal details
  (function() {
    var kysSessionId = window.ShopifyAnalytics && ShopifyAnalytics.lib && ShopifyAnalytics.lib.user ? ShopifyAnalytics.lib.user().traits().uniqToken : 'unknown-session';
    fetch('https://script.google.com/macros/s/AKfycbxrklpl2P1OtU1qEzE8UuGprCHHP4tg5Lam0sBWnbJFBc_PkzvNuBsAjY-nPNa7dbwmRg/exec', {
      method: 'POST', mode: 'no-cors', headers: {'Content-Type': 'text/plain'},
      body: JSON.stringify({
        userId: kysSessionId, name: '', email: '', phone: '',
        gender: S.gender, hasRedness: S.hasRedness, rednessType: S.rednessType,
        triggers: S.trig, otcCreams: S.otcCreams, sunscreen: S.sunscreen,
        sleepQ: S.sleepQ, dietQ: S.dietQ, hydroQ: S.hydroQ, score: calcScore()
      })
    }).catch(function(){});
  })();

  w.innerHTML=h;
  setTimeout(function(){
    var arc=document.getElementById('ring-arc');
    if(arc) arc.style.strokeDashoffset=ringFull*(1-ringTarget);
  },80);

  if(S.lead){
    var _imgs=w.querySelectorAll('img');
    var _total=_imgs.length,_loaded=0;
    function _onImgDone(){
      _loaded++;
      if(_loaded>=_total) setTimeout(function(){bgUploadResultPdf(w);},400);
    }
    if(_total===0){
      setTimeout(function(){bgUploadResultPdf(w);},400);
    } else {
      for(var _ii=0;_ii<_imgs.length;_ii++){
        if(_imgs[_ii].complete){_onImgDone();}
        else{_imgs[_ii].onload=_onImgDone;_imgs[_ii].onerror=_onImgDone;}
      }
    }
  }
};

function openUpload(key){
  document.getElementById('upload-'+key).click();
}
function openCamera(key){
  S.currentPhotoKey=key;
  var screen=document.getElementById('cameraScreen');
  screen.style.display='flex';
  document.body.style.overflow='hidden';
  navigator.mediaDevices.getUserMedia({video:{facingMode:'user'}})
    .then(function(stream){
      window.currentCameraStream=stream;
      document.getElementById('cameraVideo').srcObject=stream;
    });
}
function closeCamera(){
  document.getElementById('cameraScreen').style.display='none';
  document.body.style.overflow='';
  if(window.currentCameraStream){
    window.currentCameraStream.getTracks().forEach(function(track){track.stop();});
  }
}
function capturePhoto(){
  var video=document.getElementById('cameraVideo');
  var canvas=document.createElement('canvas');
  canvas.width=video.videoWidth;
  canvas.height=video.videoHeight;
  canvas.getContext('2d').drawImage(video,0,0);
  var image=canvas.toDataURL('image/jpeg');
  var key=S.currentPhotoKey;
  S.photos[key]=image;
  S.ps[key]='verified';
  closeCamera();
  go(curIdx,false);
}
document.addEventListener('click',function(e){
  if(e.target.id==='captureBtn') capturePhoto();
});

function openLeadPopup(context){
  var isBooking=(context==='booking');
  var titleEl=document.querySelector('#leadPopup .lead-title');
  var btnEl=document.querySelector('#leadPopup button[onclick="submitLead()"]');
  if(titleEl) titleEl.textContent=isBooking?'Confirm Your Booking':'Download Your Results';
  if(btnEl) btnEl.textContent=isBooking?'Confirm Booking':'Download PDF';
  document.getElementById('leadPopup').style.display='flex';
  document.body.style.overflow='hidden';
}
function closeLeadPopup(){
  document.getElementById('leadPopup').style.display='none';
  document.body.style.overflow='';
}
function submitLead(){
  var name=document.getElementById('lp_name').value.trim();
  var email=document.getElementById('lp_email').value.trim();
  var phone=document.getElementById('lp_phone').value.trim();
  var valid=true;
  document.querySelectorAll('.lp-errmsg').forEach(function(el){el.style.display='none';});
  if(!name){document.getElementById('err_name').style.display='block';valid=false;}
  var emailRegex=/^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if(!emailRegex.test(email)){document.getElementById('err_email').style.display='block';valid=false;}
  var phoneRegex=/^[0-9]{10}$/;
  if(!phoneRegex.test(phone)){document.getElementById('err_phone').style.display='block';valid=false;}
  if(!valid) return;
  S.lead={name:name,email:email,phone:phone};
  trackSensitiveQuizLeadCaptured(S.isChosen);
  saveQuizAnswers();
  var _resultScreen=document.querySelector('.screen');
  if(_resultScreen) setTimeout(function(){bgUploadResultPdf(_resultScreen);},500);
  var tagFormData=new FormData();
  tagFormData.append('name',name);
  tagFormData.append('email',email);
  tagFormData.append('phone',phone);
  tagFormData.append('customTag','senstive-skin-analyser');
  // https://cpos.chosenstore.in/api/shopify/customer/tag-exist
  fetch('https://cpos.chosenstore.in/api/shopify/customer/tag',{
    method:'POST',body:tagFormData,headers:{'Accept':'application/json'}
  }).then(function(res){return res.json();}).then(function(data){console.log('Customer Tag Added:',data);}).catch(function(err){console.log('Tag API Error:',err);});
  closeLeadPopup();
  if(window._pendingBooking){
    window._pendingBooking=false;
    savePendingBooking(name,email,phone);
  } else if(window._pendingPdf){
    window._pendingPdf=false;
    downloadResultPDF();
  }
}

function saveQuizAnswers(){
  if(!S.lead) return;
  var snapshot={
    personalDetails:{name:S.lead.name,email:S.lead.email,phone:S.lead.phone},
    quizData:{gender:S.gender,hasRedness:S.hasRedness,rednessType:S.rednessType,triggers:S.trig,triggerScores:S.ts,otcCreams:S.otcCreams,sunscreen:S.sunscreen,sleepQ:S.sleepQ,dietQ:S.dietQ,hydroQ:S.hydroQ,isChosenCustomer:S.isChosen,photos:S.photos},
    result:{score:calcScore()},
    savedAt:new Date().toISOString()
  };
  try{localStorage.setItem('skin_quiz_answers',JSON.stringify(snapshot));console.log('Saved in localStorage');}catch(e){console.warn('localStorage failed',e);}
  var sessionId=Date.now().toString();
  var formData=new FormData();
  formData.append('formId','senstive_skin_analyser');
  formData.append('userId',sessionId);
  formData.append('data',JSON.stringify([{personalDetails:snapshot.personalDetails},{questions:snapshot.quizData},{result:snapshot.result}]));
  formData.append('folder','senstiveskin-quiz');
  fetch('https://api.chosenstore.in/chosen-form',{method:'POST',body:formData})
    .then(function(res){return res.json();})
    .then(function(response){console.log('Quiz data saved:',response);})
    .catch(function(error){console.warn('API error:',error);});
  var kysSessionId = window.ShopifyAnalytics && ShopifyAnalytics.lib && ShopifyAnalytics.lib.user ? ShopifyAnalytics.lib.user().traits().uniqToken : 'unknown-session';
  fetch('https://script.google.com/macros/s/AKfycbxrklpl2P1OtU1qEzE8UuGprCHHP4tg5Lam0sBWnbJFBc_PkzvNuBsAjY-nPNa7dbwmRg/exec',{
    method:'POST',mode:'no-cors',headers:{'Content-Type':'text/plain'},
    body:JSON.stringify({userId:kysSessionId,name:S.lead.name,email:S.lead.email,phone:S.lead.phone,gender:S.gender,hasRedness:S.hasRedness,rednessType:S.rednessType,triggers:S.trig,otcCreams:S.otcCreams,sunscreen:S.sunscreen,sleepQ:S.sleepQ,dietQ:S.dietQ,hydroQ:S.hydroQ,score:calcScore()})
  }).catch(function(err){console.log('Sheet API Error:',err);});
  try{
    trackWebEngageSkinFormSubmitted(S.lead.email,S.lead.name,S.lead.phone);
  }catch(weErr){
    console.error('WebEngage tracking error (non-blocking):',weErr);
  }
}

async function downloadResultPDF(){
  trackSensitiveQuizPdfDownloaded();
  try{
    const{jsPDF}=window.jspdf;
    var originalScreen=document.querySelector('.screen');
    if(!originalScreen){alert('Result page not found');return;}
    var btn=document.querySelector('[onclick="downloadResultPDF()"]');
    var loader=document.createElement('div');
    loader.id='pdf-loader-text';loader.innerHTML='Preparing PDF...';
    loader.style.fontSize='11px';loader.style.marginTop='6px';loader.style.textAlign='center';loader.style.color='#555';loader.style.fontFamily='Inter, sans-serif';
    if(btn){btn.disabled=true;btn.style.opacity='0.6';if(!document.getElementById('pdf-loader-text'))btn.parentNode.insertBefore(loader,btn.nextSibling);}
    var clone=originalScreen.cloneNode(true);
    clone.style.animation='none';clone.style.transition='none';clone.style.opacity='1';clone.style.transform='none';
    clone.querySelectorAll('form, button').forEach(function(node){node.style.display='none';});
    var loaderClone=clone.querySelector('#pdf-loader-text');
    if(loaderClone) loaderClone.remove();
    var tempWrap=document.createElement('div');
    tempWrap.style.position='absolute';tempWrap.style.left='-99999px';tempWrap.style.top='0';
    tempWrap.style.width=originalScreen.offsetWidth+'px';tempWrap.style.background='#fff';tempWrap.style.paddingBottom='60px';
    tempWrap.appendChild(clone);document.body.appendChild(tempWrap);
    const fullCanvas=await html2canvas(clone,{scale:1.5,useCORS:true,backgroundColor:'#ffffff',scrollY:0,windowWidth:originalScreen.offsetWidth});
    const pdf=new jsPDF('p','mm','a4');
    const pdfWidth=210,pdfHeight=297,margin=10;
    const usableWidth=pdfWidth-(margin*2),usableHeight=pdfHeight-(margin*2);
    const imgWidth=usableWidth;
    const pageCanvasHeight=Math.floor((usableHeight*fullCanvas.width)/usableWidth);
    var fullCtx=fullCanvas.getContext('2d');
    var allPixels=null;
    try{allPixels=fullCtx.getImageData(0,0,fullCanvas.width,fullCanvas.height).data;}catch(e){}
    function findBreakPoint(startY,maxEndY){
      if(!allPixels) return maxEndY;
      var scanFrom=Math.floor(startY+(maxEndY-startY)*0.7);
      for(var y=maxEndY-1;y>=scanFrom;y--){
        var rowOff=y*fullCanvas.width*4;var isLight=true;
        for(var x=0;x<fullCanvas.width;x++){var i=rowOff+x*4;if(allPixels[i]<230||allPixels[i+1]<230||allPixels[i+2]<230){isLight=false;break;}}
        if(isLight) return y;
      }
      return maxEndY;
    }
    var renderedHeight=0,pageIndex=0;
    while(renderedHeight<fullCanvas.height){
      var remaining=fullCanvas.height-renderedHeight;
      var sliceHeight;
      if(remaining<=pageCanvasHeight){sliceHeight=remaining;}
      else{var hardEnd=Math.min(renderedHeight+pageCanvasHeight,fullCanvas.height);var breakY=findBreakPoint(renderedHeight,hardEnd);sliceHeight=breakY-renderedHeight;if(sliceHeight<=0)sliceHeight=pageCanvasHeight;}
      var pageCanvas=document.createElement('canvas');pageCanvas.width=fullCanvas.width;pageCanvas.height=sliceHeight;
      pageCanvas.getContext('2d').drawImage(fullCanvas,0,renderedHeight,fullCanvas.width,sliceHeight,0,0,fullCanvas.width,sliceHeight);
      var imgData=pageCanvas.toDataURL('image/jpeg',0.92);
      if(pageIndex>0) pdf.addPage();
      pdf.addImage(imgData,'JPEG',margin,margin,imgWidth,(sliceHeight*imgWidth)/fullCanvas.width);
      renderedHeight+=sliceHeight;pageIndex++;
    }
    document.body.removeChild(tempWrap);
    pdf.save('skin-analysis-result.pdf');
    if(btn){btn.disabled=false;btn.style.opacity='1';}
    var oldLoader=document.getElementById('pdf-loader-text');
    if(oldLoader) oldLoader.remove();
  }catch(error){
    console.error('PDF generation failed:',error);
    var btn=document.querySelector('[onclick="downloadResultPDF()"]');
    if(btn){btn.disabled=false;btn.style.opacity='1';}
    var oldLoader=document.getElementById('pdf-loader-text');
    if(oldLoader) oldLoader.remove();
  }
}

async function bgUploadResultPdf(el){
  if(!S.lead) return;
  try{
    var originalScreen=el||document.querySelector('.screen');
    if(!originalScreen) return;
    var clone=originalScreen.cloneNode(true);
    clone.style.animation='none';clone.style.transition='none';clone.style.opacity='1';clone.style.transform='none';
    clone.querySelectorAll('form, button').forEach(function(node){node.style.display='none';});
    var tempWrap=document.createElement('div');
    tempWrap.style.position='absolute';tempWrap.style.left='-99999px';tempWrap.style.top='0';
    tempWrap.style.width=originalScreen.offsetWidth+'px';tempWrap.style.background='#fff';tempWrap.style.paddingBottom='60px';
    tempWrap.appendChild(clone);document.body.appendChild(tempWrap);
    const fullCanvas=await html2canvas(clone,{scale:1.5,useCORS:true,backgroundColor:'#ffffff',scrollY:0,windowWidth:originalScreen.offsetWidth});
    document.body.removeChild(tempWrap);
    const{jsPDF}=window.jspdf;
    const pdf=new jsPDF('p','mm','a4');
    const pdfWidth=210,pdfHeight=297,margin=10;
    const usableWidth=pdfWidth-margin*2,usableHeight=pdfHeight-margin*2;
    const imgWidth=usableWidth;
    const pageCanvasHeight=Math.floor((usableHeight*fullCanvas.width)/usableWidth);
    var fullCtx=fullCanvas.getContext('2d');
    var allPixels=null;
    try{allPixels=fullCtx.getImageData(0,0,fullCanvas.width,fullCanvas.height).data;}catch(e){}
    function findBreakPoint(startY,maxEndY){
      if(!allPixels) return maxEndY;
      var scanFrom=Math.floor(startY+(maxEndY-startY)*0.7);
      for(var y=maxEndY-1;y>=scanFrom;y--){
        var rowOff=y*fullCanvas.width*4;var isLight=true;
        for(var x=0;x<fullCanvas.width;x++){var i=rowOff+x*4;if(allPixels[i]<230||allPixels[i+1]<230||allPixels[i+2]<230){isLight=false;break;}}
        if(isLight) return y;
      }
      return maxEndY;
    }
    var renderedHeight=0,pageIndex=0;
    while(renderedHeight<fullCanvas.height){
      var remaining=fullCanvas.height-renderedHeight;var sliceHeight;
      if(remaining<=pageCanvasHeight){sliceHeight=remaining;}
      else{var hardEnd=Math.min(renderedHeight+pageCanvasHeight,fullCanvas.height);var breakY=findBreakPoint(renderedHeight,hardEnd);sliceHeight=breakY-renderedHeight;if(sliceHeight<=0)sliceHeight=pageCanvasHeight;}
      var pageCanvas=document.createElement('canvas');pageCanvas.width=fullCanvas.width;pageCanvas.height=sliceHeight;
      pageCanvas.getContext('2d').drawImage(fullCanvas,0,renderedHeight,fullCanvas.width,sliceHeight,0,0,fullCanvas.width,sliceHeight);
      var imgData=pageCanvas.toDataURL('image/jpeg',0.92);
      if(pageIndex>0) pdf.addPage();
      pdf.addImage(imgData,'JPEG',margin,margin,imgWidth,(sliceHeight*imgWidth)/fullCanvas.width);
      renderedHeight+=sliceHeight;pageIndex++;
    }
    saveSkinQuizPdfToDrive(pdf.output('blob'));
  }catch(error){console.error('Background PDF upload failed:',error);}
}

function saveSkinQuizPdfToDrive(pdfBlob){
  var lead=S.lead;
  var driveFilename='skin_quiz_result_'+(lead.phone||Date.now())+'.pdf';
  var reader=new FileReader();
  reader.onloadend=function(){
    var base64Data=reader.result.split(',')[1];
    console.log('Uploading skin quiz PDF to Drive: '+driveFilename);
    fetch('https://script.google.com/macros/s/AKfycbxm5sCjw6ZPm9f5Ig2jc3IXCevz_pcKMqOd9TPDT0Ss-qrURtVIYH2SaNhtR9Yn1TBGdA/exec',{
      method:'POST',headers:{'Content-Type':'text/plain'},
      body:JSON.stringify({action:'savePdf',filename:driveFilename,pdfBase64:base64Data,email:lead.email,name:lead.name})
    }).then(function(res){return res.json();}).then(function(result){
      console.log('Drive response:',result);
      if(result.success&&result.url){
        fetch('https://script.google.com/macros/s/AKfycbzBdxpoh4SEi9Z0brnRK9JFwA5y_pzmmM5lsxRo_ATeOPwK1FX0xJMAUqIqDokyKOsF/exec',{
          method:'POST',mode:'no-cors',headers:{'Content-Type':'text/plain'},
          body:JSON.stringify({phone:lead.phone,userId:(window.ShopifyAnalytics&&ShopifyAnalytics.lib&&ShopifyAnalytics.lib.user?ShopifyAnalytics.lib.user().traits().uniqToken:'unknown-session'),name:lead.name,email:lead.email,skin_quiz_result_pdf:result.url})
        }).then(function(){console.log('PDF URL saved to sheet');}).catch(function(err){console.error('Sheet save error:',err);});
        var sagepilotSensitiveUrl=S.isChosen==='yes'
          ?'https://api.sagepilot.ai/webhooks/custom/sensitive_assessment_old/2777c037-6614-409d-abf1-8fc048411307/3f85a0d4-c426-4ef0-bd71-e33612da2a07'
          :'https://api.sagepilot.ai/webhooks/custom/sensitive_assessment_new/2777c037-6614-409d-abf1-8fc048411307/3f85a0d4-c426-4ef0-bd71-e33612da2a07';
        fetch(sagepilotSensitiveUrl,{
          method:'POST',mode:'no-cors',headers:{'Content-Type':'text/plain'},
          body:JSON.stringify({name:lead.name,email:lead.email,phone_number:'+91'+lead.phone,pdf_url:result.url})
        }).then(function(){console.log('✅ SagePilot sensitive webhook fired ('+(S.isChosen==='yes'?'old':'new')+' customer)');}).catch(function(err){console.warn('SagePilot sensitive webhook error:',err);});
      }
    }).catch(function(err){console.error('Drive upload error:',err);});
  };
  reader.readAsDataURL(pdfBlob);
}

// Replace with your Google Apps Script URL from Step 1
const BOOKING_SHEET_URL = 'https://script.google.com/macros/s/AKfycbwd0yrhHr_QLIYMSMe3zbGxOgtsN0hzIv644bndrIRa5o9stbV_vmyIFzbRjJj8MFnx/exec';

// Function to save booking with personal details to Google Sheet
function saveBookingToSheet(bookingDate, bookingTime) {
  if (!S.lead) {
    console.error('No lead data found. Please fill personal details first.');
    return;
  }
  
  const data = {
    name: S.lead.name,
    email: S.lead.email,
    phone: S.lead.phone,
    bookingDate: bookingDate,
    bookingTime: bookingTime,
    bookingType: bkState.source
  };
  
  console.log('Saving booking data:', data);
  
  fetch(BOOKING_SHEET_URL, {
    method: 'POST',
    mode: 'no-cors',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data)
  })
  .then(() => {
    console.log('Booking saved to Google Sheet successfully');
    saveBookingToLocalStorage(data);
  })
  .catch(error => {
    console.error('Error saving booking:', error);
  });
}

// Backup: Save to localStorage
function saveBookingToLocalStorage(bookingData) {
  try {
    let bookings = JSON.parse(localStorage.getItem('skin_quiz_bookings') || '[]');
    bookings.push({
      ...bookingData,
      savedAt: new Date().toISOString()
    });
    localStorage.setItem('skin_quiz_bookings', JSON.stringify(bookings));
  } catch(e) {
    console.warn('localStorage save failed', e);
  }
}

// Booking calendar
var bkState={dateIdx:0,slot:null,days:[],source:'consultation'};
function openBk(source){
  trackSensitiveQuizConsultation(source||'consultation');
  bkState.source=source||'consultation';
  var overlay=document.getElementById('bkOverlay');
  overlay.classList.add('open');
  var valetMsg=document.getElementById('bk-valet-msg');
  if(valetMsg) valetMsg.style.display=bkState.source==='specialist'?'block':'none';
  renderBk();
  document.body.style.overflow='hidden';
}
function closeBk(){
  document.getElementById('bkOverlay').classList.remove('open');
  document.body.style.overflow='';
}
function renderBk(){
  var days=[];
  var d=new Date();d.setHours(0,0,0,0);
  var closed=[0];
  while(days.length<14){
    if(!closed.includes(d.getDay())) days.push(new Date(d));
    d.setDate(d.getDate()+1);
  }
  bkState.days=days.map(function(x){return x.toISOString();});
  var WD=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  var MO=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var dpHtml=days.map(function(day,i){
    return '<button class="bk-dp'+(i===0?' bk-sel':'')+'" onclick="bkSelDate(this)" data-idx="'+i+'">'
      +'<span class="bk-dp-wd">'+WD[day.getDay()]+'</span>'
      +'<span class="bk-dp-d">'+day.getDate()+'</span>'
      +'<span class="bk-dp-m">'+MO[day.getMonth()]+'</span>'
      +'</button>';
  }).join('');
  document.getElementById('bkBody').innerHTML=
    '<label class="bk-lbl" style="margin-top:0">Select a date</label>'
    +'<div class="bk-dates" id="bkDates">'+dpHtml+'</div>'
    +'<label class="bk-lbl" style="margin-top:16px">Available slots</label>'
    +'<div class="bk-slots" id="bkSlots">'+renderBkSlots(0)+'</div>'
    +'<div class="bk-actions">'
    +'<button class="bk-cancel" onclick="closeBk()">Cancel</button>'
    +'<button class="bk-confirm" id="bkConfirm" onclick="bkConfirm()" disabled>Confirm booking</button>'
    +'</div>';
  bkState.dateIdx=0;bkState.slot=null;
}
function renderBkSlots(dateIdx){
  var now=new Date();
  var selectedDate=new Date(bkState.days[dateIdx]);
  var isToday=selectedDate.toDateString()===now.toDateString();
  var curH=now.getHours();
  var curM=now.getMinutes();
  var html='';
  for(var h=10;h<18;h++){
    for(var m=0;m<60;m+=15){
      var past=isToday&&(h<curH||(h===curH&&m<=curM));
      var hh=(h%12===0?12:h%12);
      var mm=m<10?'0'+m:''+m;
      var per=h<12?'AM':'PM';
      var label=hh+':'+mm+' '+per;
      if(past){
        html+='<button class="bk-sp" disabled style="opacity:0.35;cursor:not-allowed;pointer-events:none">'+label+'</button>';
      } else {
        html+='<button class="bk-sp" onclick="bkSelSlot(this)">'+label+'</button>';
      }
    }
  }
  return html;
}
function bkSelDate(btn){
  document.querySelectorAll('#bkDates .bk-dp').forEach(function(p){p.classList.remove('bk-sel');});
  btn.classList.add('bk-sel');
  bkState.dateIdx=parseInt(btn.dataset.idx);
  document.getElementById('bkSlots').innerHTML=renderBkSlots(bkState.dateIdx);
  bkState.slot=null;
  document.getElementById('bkConfirm').disabled=true;
}
function bkSelSlot(btn){
  document.querySelectorAll('#bkSlots .bk-sp').forEach(function(p){p.classList.remove('bk-sel');});
  btn.classList.add('bk-sel');
  bkState.slot=btn.textContent;
  document.getElementById('bkConfirm').disabled=false;
}
// function bkConfirm(){
//   if(!bkState.slot) return;
//   var date=new Date(bkState.days[bkState.dateIdx]);
//   var WDF=['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
//   var MOF=['January','February','March','April','May','June','July','August','September','October','November','December'];
//   document.getElementById('bkBody').innerHTML=
//     '<div class="bk-confirm-msg">&#10003; Booking confirmed</div>'
//     +'<div class="bk-confirm-sub">'+WDF[date.getDay()]+', '+date.getDate()+' '+MOF[date.getMonth()]+' at '+bkState.slot+'</div>'
//     +'<div style="margin-top:28px"><button class="bk-confirm" style="width:100%" onclick="closeBk()">Done</button></div>';
// }
function handlePdfClick(){
  if(S.lead){
    downloadResultPDF();
  } else {
    window._pendingPdf=true;
    openLeadPopup();
  }
}
function bkConfirm(){
  if(!bkState.slot) return;
  closeBk();
  if(S.lead){
    savePendingBooking(S.lead.name,S.lead.email,S.lead.phone);
  } else {
    window._pendingBooking=true;
    openLeadPopup('booking');
  }
}

function savePendingBooking(name,email,phone){
  var date=new Date(bkState.days[bkState.dateIdx]);
  var WDF=['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  var MOF=['January','February','March','April','May','June','July','August','September','October','November','December'];
  var formattedDate=WDF[date.getDay()]+', '+date.getDate()+' '+MOF[date.getMonth()];
  var formattedTime=bkState.slot;

  var overlay=document.getElementById('bkOverlay');
  overlay.classList.add('open');
  document.body.style.overflow='hidden';
  document.getElementById('bkBody').innerHTML='<div style="text-align:center;padding:40px 20px"><div style="font-size:16px;color:#1A1412;margin-bottom:12px">Confirming your booking...</div><div style="font-size:13px;color:#5B524C">Please wait</div></div>';

  var kysSessionId=window.ShopifyAnalytics&&ShopifyAnalytics.lib&&ShopifyAnalytics.lib.user?ShopifyAnalytics.lib.user().traits().uniqToken:'unknown-session';
  var bookingData={userId:kysSessionId,name:name,email:email,phone:phone,bookingDate:formattedDate,bookingTime:formattedTime,bookingType:bkState.source};

  try {
    var weBookingDateTime = new Date(date);
    var weSlotMatch = (formattedTime || '').match(/(\d+):(\d+)\s*(AM|PM)/i);
    if (weSlotMatch) {
      var weSlotH = parseInt(weSlotMatch[1], 10);
      var weSlotM = parseInt(weSlotMatch[2], 10);
      var weSlotAP = weSlotMatch[3].toUpperCase();
      if (weSlotAP === 'PM' && weSlotH !== 12) weSlotH += 12;
      if (weSlotAP === 'AM' && weSlotH === 12) weSlotH = 0;
      weBookingDateTime.setHours(weSlotH, weSlotM, 0, 0);
    }
    trackWebEngageConsultationBooked(weBookingDateTime.toISOString(), formattedTime);
  } catch (weErr) {
    console.error('WebEngage tracking error (non-blocking):', weErr);
  }


  function showConfirmed(){
    document.getElementById('bkBody').innerHTML=
      '<div class="bk-confirm-msg">✓ Booking Confirmed!</div>'
      +'<div class="bk-confirm-sub">'+formattedDate+' at '+formattedTime+'</div>'
      +'<div style="margin-top:12px;font-size:13px;color:#5B524C;text-align:center">Confirmation sent to '+email+'</div>'
      +'<div style="margin-top:8px;font-size:12px;color:#A89F97;text-align:center">We\'ll contact you at '+phone+'</div>'
      +'<div style="margin-top:28px"><button class="bk-confirm" style="width:100%" onclick="closeBk()">Done</button></div>';
  }

  fetch(BOOKING_SHEET_URL,{method:'POST',mode:'no-cors',headers:{'Content-Type':'application/json'},body:JSON.stringify(bookingData)})
    .then(function(){showConfirmed();}).catch(function(){showConfirmed();});
}
// Boot
go(0);